var React = require('react');

function Otherpin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined-Shape"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"other_pin","fill":"#4F4F4F","fillRule":"nonzero"},React.createElement("path",{"d":"M8,19.5555555 C6.48010255,19.5555555 0,12.4536577 0,8.02279203 C0,3.59192634 3.58172201,-3.99680289e-14 8,-3.99680289e-14 C12.418278,-3.99680289e-14 16,3.59192634 16,8.02279203 C16,12.4536577 9.51989745,19.5555555 8,19.5555555 Z M8,13.0909091 C10.8116314,13.0909091 13.0909091,10.8116314 13.0909091,8 C13.0909091,5.18836855 10.8116314,2.90909091 8,2.90909091 C5.18836855,2.90909091 2.90909091,5.18836855 2.90909091,8 C2.90909091,10.8116314 5.18836855,13.0909091 8,13.0909091 Z","id":"Combined-Shape"})))]);
}

Otherpin.defaultProps = {"width":"16px","height":"20px","viewBox":"0 0 16 20","version":"1.1"};

module.exports = Otherpin;

Otherpin.default = Otherpin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/otherpin.svg
// module id = 1503
// module chunks = 0